<template>
  <div class="PageFeedback m-fb-col m-fb-cross-center">
    <CommonHeader title="问题反馈"></CommonHeader>
    <CommonBox class="m-fb-col">
      <div class="feedback-wrap m-p-48 m-item-flex-1">
        <p class="feedback-title required"> 问题发生场景 </p>
        <div class="m-mb-48">
          <m-radiobox
            class="m-mr-24"
            :label="it.label"
            v-model="postData.businessType"
            :checkVal="it.value"
            v-for="it in businessTypeList"
            :key="it.value"
          ></m-radiobox>
        </div>
        <p class="feedback-title required"> 问题描述 </p>
        <m-textarea
          class="m-mb-48"
          v-model="postData.content"
          :resize="true"
          :height="120"
          placeholder="请填写10个字以上的问题描述"
          :maxlength="500"
        ></m-textarea>
        <p class="feedback-title"> 上传凭证 </p>
        <CommonUploadImg @handlerUpload="handlerToUploadFaceimg" :imgList="postData.imgList"></CommonUploadImg>
        <MTips type="default" class="m-mt-8 m-font-12">图片大小5M以内，上限3张</MTips>
      </div>
      <div class="m-fb-center-center footer m-p-18-0">
        <div class="m-mr-16 but" @click="handlerCancel"> 取消 </div>
        <div class="but m-bg-003F88 m-c-FFFFFF" @click="handlerSubmit" :class="{ disable: computedSubmitStatus }">
          保存
        </div>
      </div>
    </CommonBox>
  </div>
</template>
<script>
import { uni } from 'CONFIG'
export default {
  data() {
    return {
      uni,
      businessTypeList: [
        {
          label: '公共场馆预约',
          value: 2
        },
        {
          label: '其他',
          value: 0
        }
      ],
      postData: {
        businessType: null, // 问题发生场景
        content: '', // 问题描述
        imgUrlList: [] // 凭证图片集合
      }
    }
  },
  computed: {
    computedSubmitStatus() {
      if (this.postData.businessType !== null && this.postData.content) {
        return false
      }
      return true
    }
  },
  mounted() {
    if (this.uni === 'zheda') {
      this.businessTypeList.unshift({
        label: '自习空间查询',
        value: 1
      })
    }
  },
  methods: {
    // 更新照片
    handlerToUploadFaceimg(val) {
      this.postData.imgUrlList = val
    },
    // 取消
    handlerCancel() {
      this.$router.back()
    },
    /**
     * @Description: 提交反馈
     * @return {*}
     */
    handlerSubmit() {
      if (this.computedSubmitStatus) return
      if (this.postData.content.length < 10) {
        this.$mmessage({
          type: 'error',
          message: '请至少描述10个字'
        })
        return false
      }
      this.fetchFeedbackCreate().then(() => {
        this.$mmessage({
          type: 'success',
          message: '提交成功，感谢您的反馈'
        })
        setTimeout(() => {
          this.$router.back()
        }, 2000)
      })
    },
    /**
     * @Description: 问题反馈创建
     * @return {*}
     */
    fetchFeedbackCreate() {
      return this.$httpPost('feedbackCreate', this.postData)
    }
  }
}
</script>

<style scoped lang="scss">
.feedback-wrap {
  width: 700px;
  margin: 0 auto;
  .feedback-title {
    font-size: 16px;
    margin-bottom: 24px;
    font-weight: 800;
  }
  .required {
    &::before {
      content: '*';
      color: red;
      margin-right: 6px;
    }
  }
}
.footer {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(51, 51, 51, 0.08);
  .but {
    width: 88px;
    line-height: 36px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
  }
  .disable {
    opacity: 0.3;
  }
}
</style>
